import './App.css';
import { Route, Routes } from 'react-router-dom';
import Courses from './components/courses/Course';
import ResponsiveAppBar from './components/appbar/ResponsiveAppBar';
import Home from './components/home/Home';
import Presentations from './components/presentations/Presentations';
import About from './components/about/About';
import Exams from './components/exams/Exams';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div>
      <ResponsiveAppBar />
      <Routes>
        <Route path="/courses" element={<Courses />} />
        <Route path="/presentations" element={<Presentations />} />
        <Route path="/about" element={<About />} />
        <Route path="/exams" element={<Exams />} />
        <Route path="/minimal-apis/" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
